__turbopack_context__.v({
  "accent": "Button-module__bKPjLa__accent",
  "button": "Button-module__bKPjLa__button",
  "destructive": "Button-module__bKPjLa__destructive",
  "fullWidth": "Button-module__bKPjLa__fullWidth",
  "hasEndIcon": "Button-module__bKPjLa__hasEndIcon",
  "hasStartIcon": "Button-module__bKPjLa__hasStartIcon",
  "icon": "Button-module__bKPjLa__icon",
  "iconSpin": "Button-module__bKPjLa__iconSpin",
  "label": "Button-module__bKPjLa__label",
  "lg": "Button-module__bKPjLa__lg",
  "loading": "Button-module__bKPjLa__loading",
  "md": "Button-module__bKPjLa__md",
  "noPadding": "Button-module__bKPjLa__noPadding",
  "primary": "Button-module__bKPjLa__primary",
  "secondary": "Button-module__bKPjLa__secondary",
  "sm": "Button-module__bKPjLa__sm",
  "spin": "Button-module__bKPjLa__spin",
  "spinner": "Button-module__bKPjLa__spinner",
  "spinnerIcon": "Button-module__bKPjLa__spinnerIcon",
  "tertiary": "Button-module__bKPjLa__tertiary",
  "tertiaryPink": "Button-module__bKPjLa__tertiaryPink",
});
